const FileIcon = ({ className }: { className?: string }) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1655_516)">
<path d="M38.032 14.125H23L21 12H11C10 12 9 13 9 13.9511V34C9 35 10 36 11.2 36H38.032C39.12 36 40 35.125 40 34.0781V16C40 15 39 14.125 38.032 14.125ZM38.032 34H11V13.9511H20L22 16H38.032V34ZM34 23H14V21H34V23ZM29 29H14V27H29V29Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1655_516">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>

);

export default FileIcon;
